export const formatText = (text: string) => {
  text = text.replace(/<right>/g, '<p style="text-align: right;" >');
  text = text.replace(/<\/right> <\/left>/g, '</p>');
  text = text.replace(/<left>/g, '<p style="text-align: left;" >');
  text = text.replace(/<\/microsoft>/g, '</iframe>');
  text = text.replace(/<video>/g, `<video controls autoplay name="media"`);

  text = text.replace(
    /<microsoft /g,
    `<iframe allowFullScreen allow='autoplay' class="pptx-content" src=https://view.officeapps.live.com/op/embed.aspx?`
  );

  return text;
};
